import React, { useState, useEffect, useImperativeHandle ,forwardRef} from 'react';
import tips from '../../public/img/tips.png';
import './messagesTop.css';


let MessagesTop = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);

    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow
        }
    });

    /**
     * 消息内容换行处理
     */
    useEffect(() => {
        let arr = content.split(';');
        if (arr.length > 1) {
            let index = 1;
            let newContent = '';
            arr.map((item) => {
                if (item.trim() !== '') {
                    newContent += index++ + '.' + item + '\n'
                }
            });
            setContent(newContent);
        }
    }, [content]);


    return (
        <>
            {
                isShow &&
                <div className='messagesTop'>
                    <div className='messageTopLeftBox'>
                        <img className='messagesTopImg' src={tips}></img>
                    </div>
                    <div className='messageTopRightBox'>
                        {content}
                        <div>
                            {'If you want to resubmit the job post, please edit and click "Edit & Submit" after you finish editing the job post.'}
                        </div>
                    </div>
                </div>
            }
        </>
    )

}

MessagesTop = forwardRef(MessagesTop);
export default MessagesTop;